import { ReportingDeviceConfig } from './map-types';

export const SITE_ZOOM_LEVEL = 13;

export const REPORTING_DEVICE_CONFIG: Record<string, ReportingDeviceConfig> = {
  audio_locations: {
    name: 'Audio Locations',
    icon: '/maki_icons/svgs/mobile-phone.svg',
    type: 'audio',
  },
  camera_locations: {
    name: 'Camera Locations',
    icon: '/maki_icons/svgs/cinema.svg',
    type: 'camera',
  },
};

export const mapBoxConfig = {
  accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
  mapStyle: 'satellite-v9',
  fullscreenControl: true,
  defaulView: {
    lat: 20.5937,
    lng: 78.9629,
    zoom: 4.5,
  },
  polygon: {
    fillColor: '#90EE90',
    defaultPolygonOpacity: 0.7,
  },
  marker: {
    color: 'red',
    scale: 0.7,
  },
  icon: {
    height: 40,
    width: 40,
  },
  raterTile: {
    opacity: 0.5,
  },
  mapUIElementBackgroundColor: 'rgba(255, 255, 255, 0.9)',
};
